import { PlansTrigger, PlansTriggerLabel } from "~/features/plans/components/plans-drawer"
import { usePlans } from "~/features/plans/hooks/use-plans"

const UPSELL_WINDOW_DAYS = 5
const DAY_IN_MS = 24 * 60 * 60 * 1000

function isWithinDays(chargeDate: string, days: number) {
  const chargeTime = new Date(chargeDate).getTime()
  if (Number.isNaN(chargeTime)) return false

  const now = Date.now()
  const diff = chargeTime - now
  return diff >= 0 && diff <= days * DAY_IN_MS
}

export function PlansUpsell() {
  const { data } = usePlans()
  const currentPlan = data.plans.find((plan) => !!plan.chargeDate)

  if (currentPlan?.chargeDate && !isWithinDays(currentPlan.chargeDate, UPSELL_WINDOW_DAYS)) {
    return null
  }

  return (
    <PlansTrigger>
      <PlansTriggerLabel className="px-m min-h-0! bg-muted" />
    </PlansTrigger>
  )
}
